import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setInquiryHistoryData,
  updateInquiryLoginData,
} from "@store/inquiry/inquirySlice";
import { setFormStep } from "@store/ui/formStepSlice";
import { Box, MenuItem, Select, Typography, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Trans, useTranslation } from "react-i18next";
import "@styles/pages/Inquiry/step1/RegistrationInquiry.scss";
import { getEnrollmentList } from "@api/enrollmentApi";
import { countriesData } from "@data/GlobalData";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const RegistrationInquiry = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const inquiryLoginData = useSelector(
    (state) => state.inquiry.inquiryLoginData
  );

  const [isLoading, setIsLoading] = useState(false);

  const fetchEnrollmentList = async (d) => {
    setIsLoading(true);
    try {
      const res = await getEnrollmentList(d);
      const data = res.data.Data;

      if (data.length === 0) {
        toast.error(t("inquiry:no_record"));
        return;
      }

      dispatch(setInquiryHistoryData(data));
      dispatch(setFormStep({ formKey: "inquiry", step: 1 }));
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetEnrollmentList = () => {
    const finalData = {
      email: inquiryLoginData.email,
      phone: inquiryLoginData.select + inquiryLoginData.phone,
    };

    fetchEnrollmentList(finalData);
  };

  return (
    <Box className="registration-inquiry-container">
      <Typography className="title">
        <Trans i18nKey="inquiry:course_inquiry" />
      </Typography>
      <Typography className="enter-text">
        <Trans i18nKey="inquiry:enter_text" />
      </Typography>
      <Box className="input-container">
        <Box className="row-container">
          <Typography className="label">
            <Trans i18nKey="inquiry:email_address" />
          </Typography>
          <Box className="field-container">
            <TextField
              className="inquiry-input"
              variant="outlined"
              value={inquiryLoginData.email}
              onChange={(e) =>
                dispatch(updateInquiryLoginData({ email: e.target.value }))
              }
            />
          </Box>
        </Box>

        <Box className="row-container">
          <Typography className="label">
            <Trans i18nKey="inquiry:mobile_number" />
          </Typography>
          <Box className="field-container">
            <Select
              className="country-code"
              variant="outlined"
              value={inquiryLoginData.select}
              onChange={(e) =>
                dispatch(updateInquiryLoginData({ select: e.target.value }))
              }
            >
              {countriesData.map((item, key) => (
                <MenuItem key={key} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            <TextField
              className="inquiry-input"
              variant="outlined"
              type="tel"
              value={inquiryLoginData.phone}
              onChange={(e) =>
                dispatch(updateInquiryLoginData({ phone: e.target.value }))
              }
            />
          </Box>
        </Box>
      </Box>
      <Box className="button-container">
        <LoadingButton
          className="loading-button"
          fullWidth
          disabled={isLoading}
          loading={isLoading}
          onClick={handleGetEnrollmentList}
        >
          <Trans i18nKey="inquiry:inquiry" />
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default RegistrationInquiry;
